import React from 'react';
import { CTASection } from '../../../components/CTASection';
export function CTA() {
  return <section className="py-16 bg-white" data-id="element-451">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-452">
        <CTASection headline="Ready to Launch Your Online Store?" body="Let's discuss your e-commerce goals and build a custom platform designed for conversion and growth." buttonText="Start the Conversation" buttonLink="/contact" variant="dark" data-id="element-453" />
      </div>
    </section>;
}